import { ReactNode } from "react"
import LoadingApiQuery from "../../LoadingApiQuery"
import DisplayNotFoundInfo from "../../DisplayNotFindInfo"

export default function TemplateListagem({
    children,
    isLoading,
    isEmpty,
}: TemplateListagemProps) {
    return (
        <>
            {isLoading && <LoadingApiQuery extraParams={{
                height: 200,
                alignItems: 'center',
            }} />}
            {(isEmpty && !isLoading) && <DisplayNotFoundInfo label="Nenhum resultado encontrado" />}
            {(!isEmpty && !isLoading) && children}
        </>
    )
}

interface TemplateListagemProps {
    children: ReactNode,
    isLoading: boolean,
    isEmpty: boolean,
}
